import { render, staticRenderFns } from "./channelWithdrawal.vue?vue&type=template&id=63a94f2b&scoped=true"
import script from "./channelWithdrawal.vue?vue&type=script&lang=js"
export * from "./channelWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./channelWithdrawal.vue?vue&type=style&index=0&id=63a94f2b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a94f2b",
  null
  
)

export default component.exports